import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useAtom } from "jotai";
import { Navigate, Outlet } from "react-router-dom";
import { currentUserAtom } from "../atoms/authAtom";
import { authApi } from "../service/authApi";
import { ApiError } from "../service/apiClient";
export function ProtectedRoute() {
    const [currentUser, setCurrentUser] = useAtom(currentUserAtom);
    useEffect(() => {
        if (currentUser !== undefined)
            return;
        authApi
            .me()
            .then(setCurrentUser)
            .catch((err) => {
            if (err instanceof ApiError && err.status === 401) {
                setCurrentUser(null);
            }
            else {
                throw err;
            }
        });
    }, [currentUser, setCurrentUser]);
    if (currentUser === undefined) {
        return null;
    }
    if (currentUser === null) {
        return _jsx(Navigate, { to: "/login", replace: true });
    }
    return _jsx(Outlet, {});
}
